import { render, staticRenderFns } from "./HostelDetail.vue?vue&type=template&id=44a9ad05"
import script from "../../controllers/hostel/hostel-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/hostel/hostel-detail.js?vue&type=script&lang=js&external"
import style0 from "./HostelDetail.vue?vue&type=style&index=0&id=44a9ad05&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports